import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'icon-heart-outline',
  templateUrl: './icon-heart-outline.component.html',
  styleUrls: ['./icon-heart-outline.component.scss'],
})
export class IconHeartOutlineComponent  implements OnInit {
  @Input() size :number = 20;
  constructor() { }

  ngOnInit() {}

}
